import {
  useOrganizationSettingsActivityQuery,
  useSaveProfileMutation
} from 'generated/graphql';
import {
  useCallback,
  useMemo
} from 'react';

import { DateTime } from 'luxon';
import { FileUploadField } from 'modules';
import * as types from './types';



export interface IData {
  personId: string;
  siteUserId: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  preferredEmail: string;
  organizationName: string;
  dateCreated: DateTime;
  profilePicture: FileUploadField.IFile | null;
}

export function useQuery() {
  const tuple = useOrganizationSettingsActivityQuery({
  });



  return useMemo(
    () => {
      const user = tuple.data?.loggedInUser;
      const person = user?.person;

      const data: IData = {
        personId: person?.id ?? '',
        firstName: person?.firstName || '',
        lastName: person?.lastName || '',
        phoneNumber: person?.phoneNumber || '',
        preferredEmail: person?.preferredEmail || '',
        organizationName: person?.currentOrganization?.name ?? '',
        dateCreated: user ? user.createdTimestamp : DateTime.now(),
        siteUserId: user?.id || '',
        profilePicture: person?.profilePicture
          ? {
            apiFileId: person.profilePicture.id,
            dataUrl: person.profilePicture.url,
            filename: person.profilePicture.fileName,
            fileType: person.profilePicture.fileName.split('.')[1],
            sizeBytes: 20
          }
          : null
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useSaveProfile() {
  const [
    fnMutate,
    tuple
  ] = useSaveProfileMutation({
  });

  const fnWrappedMutate = useCallback(
    async (personId: string, formState: types.IFormState) => {
      await fnMutate({
        variables: {
          input: {
            id: personId,
            firstName: formState.firstName,
            lastName: formState.lastName,
            phoneNumber: formState.phoneNumber,
            preferredEmail: formState.preferredEmail,
            profilePictureApiFileId: formState.profilePicture?.apiFileId
          }
        }
      });
    },
    [fnMutate]
  );

  return useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
